angular.module('impactx.search').directive('ixMinimizedFilter', function () {
    return {
        scope: {
            label: '@',
            value: '=',
            onRemove: '&'
        },
        restrict: 'E',
        templateUrl: 'modules/search/templates/minimized.filter.html',
    };
});